'use client';
import type React from 'react';
import { useEffect, useRef } from 'react';

interface Props {
  stream: MediaStream;
}

export const Video: React.FC<
  Props &
    React.DetailedHTMLProps<
      React.VideoHTMLAttributes<HTMLVideoElement>,
      HTMLVideoElement
    >
> = ({ stream, ...rest }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoObj = videoRef.current;

    if (videoObj) {
      videoObj.srcObject = stream;

      videoObj.onloadedmetadata = async () => {
        try {
          await videoObj.play();
        } catch (error) {
          console.error(error);
        }
      };

      videoObj.onerror = () => {
        console.error('videoCard() | Error is hapenning...');
      };
    }
  }, []);

  return <video {...rest} ref={videoRef} autoPlay muted />;
};
